import { useContext } from "react";
import { DisplaySettingsContext } from "contexts/DisplaySettingsContext";

const useDisplaySettings = () => useContext(DisplaySettingsContext);

export default useDisplaySettings;
